export const requiredErr = 'پرکردن این فیلد الزامی است'
export const phoneErr = 'شماره موبایل معتبر نیست'
export const stringErr = 'مقدار وارد شده معتبر نیست'
export const emailErr = 'ایمیل صحیح نیست'
export const passwordErr = 'باید حداقل 6 کاراکتر باشد'
export const fullNameErr = 'این فیلد ضروری است'
export const numberErr = 'فقط اعداد مجاز است'
export const positiveNumberErr = 'عدد باید مثبت باشد'
export const shebaErr = 'شماره شبا معتبر نیست'
export const cardErr = 'شماره کارت معتبر نیست'
export const nationalCodeErr = 'کد ملی معتبر نیست'
export const ownerNameErr = 'نام صاحب حساب الزامی است'
export const bankNameErr = 'نام بانک الزامی است'
export const birthDateErr = 'تاریخ تولد معتبر نیست'

export const ValidationsMessages = {
  requiredErr,
  phoneErr,
  stringErr,
  emailErr,
  passwordErr,
  fullNameErr,
  numberErr,
  positiveNumberErr,
  shebaErr,
  cardErr,
  nationalCodeErr,
  ownerNameErr,
  bankNameErr,
  birthDateErr,
}

export default ValidationsMessages
